"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useOrderPreview = useOrderPreview;
var _shoppingContext = require("@ori/shopping-context");
var _constants = require("../../constants");
function useOrderPreview() {
    const { shoppingContext: { shoppingBag: { addedItems = [], backorderItems = [], offers = [], shoppingBagItems = [], subscriptions = [] } = {} } = {} } = (0, _shoppingContext.useShoppingContext)();
    const basketItems = [
        ...shoppingBagItems,
        ...addedItems,
        ...backorderItems
    ];
    const orderPreviewItems = [];
    basketItems.forEach((basketItem)=>{
        if (basketItem.isAvailable) {
            const existingItem = orderPreviewItems.find((item)=>item.itemCode === basketItem.itemCode);
            if (existingItem) {
                existingItem.quantity += basketItem.requestedQuantity;
            } else {
                orderPreviewItems.push({
                    itemCode: basketItem.itemCode,
                    quantity: basketItem.requestedQuantity,
                    isHidden: basketItem.itemCode === ''
                });
            }
        }
    });
    offers.forEach((offer)=>{
        offer.items.forEach((offerItem)=>{
            if (offerItem.isAvailable) {
                const existingItem = orderPreviewItems.find((item)=>item.itemCode === offerItem.itemCode);
                if (existingItem) {
                    existingItem.quantity += offerItem.requestedQuantity;
                } else {
                    orderPreviewItems.push({
                        itemCode: offerItem.itemCode,
                        quantity: offerItem.requestedQuantity
                    });
                }
            }
        });
    });
    subscriptions.forEach((subscription)=>{
        subscription.packages.forEach((subscriptionPackage)=>{
            subscriptionPackage.items.forEach((subscriptionPackageItem)=>{
                if (subscriptionPackageItem.isAvailable) {
                    const existingItem = orderPreviewItems.find((item)=>item.itemCode === subscriptionPackageItem.itemCode);
                    if (existingItem) {
                        existingItem.quantity += subscriptionPackageItem.requestedQuantity;
                    } else {
                        orderPreviewItems.push({
                            itemCode: subscriptionPackageItem.itemCode,
                            quantity: subscriptionPackageItem.requestedQuantity
                        });
                    }
                }
            });
        });
    });
    const shoppingBagItemsQuantity = orderPreviewItems.reduce((total, item)=>total + item.quantity, 0);
    const orderPreviewItemsCount = orderPreviewItems.length;
    const isMoreDesktop = orderPreviewItemsCount - _constants.MAX_DESKTOP_ITEMS > 0;
    const isMoreMobile = orderPreviewItemsCount - _constants.MAX_MOBILE_ITEMS > 0;
    return {
        isMoreDesktop,
        isMoreMobile,
        itemCount: orderPreviewItemsCount,
        orderPreviewItems,
        shoppingBagItemsQuantity
    };
}
